import V1 from '@/system-modules/mod-manager/v1/ModManagerV1'
import { ISysModManagerModule } from '@/contracts/system-modules/mod-manager/ISysModManagerModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import SystemModuleConfig from '@/contracts/system/configs/SystemModuleConfig'

export class ModManagerProvider extends Provider<ISysModManagerModule> {
  realizations: Record<string, ISysModManagerModule> = {
    v1: V1(),
  }
}
const instance: { module: ISysModManagerModule | null } = { module: null }

export function SysModManagerProviderModule(): ISysModManagerModule {
  const version = SystemModuleConfig.getModManagerVersion()

  if(!instance.module){
    instance.module = new ModManagerProvider().module(version)
  }

  return instance.module
}
